import { Component, Input } from '@angular/core';

@Component({
    selector: 'lib-progress-overlay',
    templateUrl: './progress-overlay.component.html',
    styleUrls: ['./progress-overlay.component.scss']
})
export class ProgressOverlayComponent {
    @Input() diameter = 30;
}
